import Button from '../../sharedComponents/Button/Button';
import Heading from '../../sharedComponents/Heading/Heading';
import './About.scss';
import { ReactComponent as ArrowForward } from '../../../assets/icons/arrow_forward.svg';
import AboutUsImage from '../../../assets/AboutUsImage.svg';
import { useNavigate } from 'react-router-dom';
function About() {
    let navigate = useNavigate();

    const goToAboutPage = () => {
        window.scrollTo(0, 0);
        navigate("/about");
    }
    return (
        <div id='alpha-perceptron-about' className='alpha-perceptron-about responsiveFlexBox'>
            <div className='alpha-perceptron-about__container responsiveFlexBox'>
                <div className='alpha-perceptron-about__container__textContainer'>
                    <Heading type='tertiary' size='h5'>
                        At AlphaPerceptron, we bridge the gap between imagination and reality. Our AI-driven solutions
                        empower businesses, researchers, and creators to shape the future.
                    </Heading>
                    <Button onClick={goToAboutPage} size='small' type='secondary' icon={<ArrowForward />}>Our Story</Button>
                </div>
                <div className='alpha-perceptron-about__container__imageContainer'>
                    <img src={AboutUsImage} alt='About Us'/>
                </div>
            </div>
        </div>
    );
}

export default About;

